import { ReactNode } from "react";

export function SplittedPageRight({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={className}>{children}</div>;
}
